module.exports = __webpack_public_path__ + "static/10-2d9c5ab04bacf1607243e620829db466.png";